/**
 * Get the URL with the correct host
 *
 * @author Team CMS
 * @param url - The relative or absolute URL to resolve.
 * @param cdn - The base CDN URL to use for relative paths.
 * @returns The resolved URL, with the correct host if applicable.
 */

/**
 * Resolves a URL to include the correct host if needed.
 *
 * This function checks if a given URL is:
 * 1. Absolute (starting with "http" or "//") — returns the URL as is.
 * 2. Relative (starting with "/") — prepends the CDN URL.
 * 3. Other relative paths (without a leading "/") — also prepends the CDN URL.
 *
 * @param url - The relative or absolute URL to resolve.
 * @param cdn
 * @returns The resolved URL, with the correct host if applicable.
 */
const DEFAULT_CDN = '//cdn1.test3.svenskaspel.se/content';

function getConfiguredCdn(): string {
  const configuredCdn = process.env.NEXT_PUBLIC_CDN?.replace(/\/$/, '');

  if (!configuredCdn) {
    return DEFAULT_CDN;
  }

  return configuredCdn.endsWith('/content') ? configuredCdn : `${configuredCdn}/content`;
}

const resolveCdnUrl = (url: string = '', cdn: string = getConfiguredCdn()): string => {
  if (/^(https?:)?\/\/.*/.test(url)) {
    return url;
  }
  // Remove trailing slash from CDN URL if present
  return `${cdn.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
};

export { resolveCdnUrl };
